import { createFileRoute, notFound } from '@tanstack/react-router'
import * as v from 'valibot'

import { FEATURE_DASHBOARD_EXCLUSIVE_CHANNEL } from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { ExclusiveContent } from '@/exclusive-content/components/ExclusiveContent/ExclusiveContent'

const exclusiveContentSearchSchema = v.object({
  query: v.optional(v.string()),
  status: v.optional(v.picklist(['not-started', 'in-progress', 'completed'])),
})

export const Route = createFileRoute('/_learning/_company/exclusive-content')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-my-exclusive-content',
        }),
      },
    ],
  }),
  validateSearch: exclusiveContentSearchSchema,
  beforeLoad: ({ context }) => {
    if (!context.user?.features.includes(FEATURE_DASHBOARD_EXCLUSIVE_CHANNEL)) {
      throw notFound()
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <ExclusiveContent />
}
